"use client";
import { useRef, useState } from "react";
import { track } from "@lib/track";

export default function RetreatInterestForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [hp, setHp] = useState(""); // honeypot — server decides, see app/lib/signupGuard.ts
  const mountedAt = useRef(Date.now());
  const [state, setState] = useState<"idle" | "submitting" | "done" | "already" | "error">("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !email.includes("@")) return;
    setState("submitting");
    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name.trim(),
          email: email.trim().toLowerCase(),
          hp,
          elapsedMs: Date.now() - mountedAt.current,
        }),
      });
      const data = await res.json();
      if (data.alreadySubscribed) {
        setState("already");
      } else if (data.ok) {
        setState("done");
        try {
          track("retreat_interest", { label: "Summer Solstice 2026", component: "RetreatInterestForm" }, { event: "retreat_interest", label: "Summer Solstice 2026", component: "RetreatInterestForm" });
        } catch {}
      } else {
        setState("error");
      }
    } catch {
      setState("error");
    }
  };

  if (state === "done") {
    return (
      <p className="text-center text-[var(--color-text-brand)] font-semibold text-sm py-4">
        You&apos;re on the list — we&apos;ll be in touch about future retreats.
      </p>
    );
  }

  if (state === "already") {
    return (
      <p className="text-center text-[var(--color-text-brand)] font-semibold text-sm py-4">
        You&apos;re already on the list — we&apos;ll keep you posted.
      </p>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 mt-6 max-w-md mx-auto">
      {/* Honeypot — off-screen, never filled by a human. See app/lib/signupGuard.ts */}
      <input
        type="text"
        name="contact_website"
        tabIndex={-1}
        autoComplete="off"
        value={hp}
        onChange={e => setHp(e.target.value)}
        className="absolute -left-[9999px] h-0 w-0 opacity-0"
        aria-hidden="true"
      />
      <input
        type="text"
        placeholder="Your name"
        value={name}
        onChange={e => setName(e.target.value)}
        required
        className="flex-1 rounded-xl border border-gray-200 px-4 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 bg-white focus:outline-none focus:ring-2 focus:ring-[var(--color-brand)]/40"
      />
      <input
        type="email"
        placeholder="Email address"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
        className="flex-1 rounded-xl border border-gray-200 px-4 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 bg-white focus:outline-none focus:ring-2 focus:ring-[var(--color-brand)]/40"
      />
      <button
        type="submit"
        disabled={state === "submitting"}
        className="px-6 py-2.5 bg-[var(--color-brand)] text-white text-sm font-semibold rounded-xl hover:opacity-90 transition disabled:opacity-50 whitespace-nowrap"
      >
        {state === "submitting" ? "Saving…" : "Stay in the loop"}
      </button>
      {state === "error" && (
        <p className="text-xs text-red-600 mt-1 text-center sm:col-span-3">Something went wrong — please try again.</p>
      )}
    </form>
  );
}
